import { jsx as _jsx } from "react/jsx-runtime";
import ButtonGroup from "./ButtonGroup";
import ButtonGroupItem from "./ButtonGroupItem";
const composition = (props) => (_jsx(ButtonGroup, { ...props }));
composition.Button = ButtonGroupItem;
export default composition;
